module.exports = __webpack_public_path__ + "static/badge-092a06871bf109d65e7561905d49e3a3.png";